import Icon, { BaseIconProps } from './react-components/Icon'
function MessageIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        {...props}
      >
        <path
          d="M2.85352 4.29153e-06C1.40049 4.29153e-06 0 1.44246 0 2.98907L9.25064e-05 10.4138C0.222168 12.1886 1.59112 13.1632 2.72217 13.1887H3.01453L4.22217 16.1886L6.72217 13.1886L14.5916 13.2142C16.0447 13.2142 17.4842 11.9604 17.4842 10.4138L17.4842 2.98907C17.4842 1.44246 16.0447 0 14.5916 0L2.85352 4.29153e-06Z"
          fill="#503291"
        />
        <path
          d="M3.5436 1.37288C2.26151 1.37288 1.22217 2.45949 1.22217 3.79989L1.22217 9.68854C1.22217 11.1703 2.4032 12.1156 3.80156 12.1156L4.43645 14.2602L5.92927 12.1156L13.9007 12.1155C15.9065 12.1155 16.2222 11.0289 16.2222 9.68854L16.2222 3.79989C16.2222 1.87276 15.1828 1.37288 13.9007 1.37288L3.5436 1.37288Z"
          fill="white"
        />
      </svg>
    </Icon>
  )
}
export default MessageIcon
